import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faTrashCan } from "@fortawesome/pro-solid-svg-icons";
import { BatchActionPill } from "@components/CatalogIndex";
import type { Calculation } from "./types";
import "./style.css";

export interface CalculationsListProps {
  rows: Calculation[];
  selectedIds: string[];
  setSelectedIds: (ids: string[]) => void;
  onAdd: () => void;
  onEdit: (calc: Calculation) => void;
  onBatchDelete: () => void;
}

export const CalculationsList = ({
  rows,
  selectedIds,
  setSelectedIds,
  onAdd,
  onEdit,
  onBatchDelete,
}: CalculationsListProps): JSX.Element => {
  const toggle = (id: string) =>
    setSelectedIds(
      selectedIds.includes(id)
        ? selectedIds.filter((x) => x !== id)
        : [...selectedIds, id]
    );

  return (
    <div className="calculations-tab-card">
      <div className="calculations-tab-card__header">
        <h2 className="calculations-tab-card__title">Survey Calculations</h2>
        <div className="calculations-tab-card__actions">
          <BatchActionPill
            selectedCount={selectedIds.length}
            actions={[
              {
                icon: faTrashCan,
                label: "Delete",
                onClick: onBatchDelete,
                variant: "danger",
              },
            ]}
          />
          <Button className="squareGreenButton" onClick={onAdd}>
            Add Calculation
          </Button>
        </div>
      </div>

      {rows.length === 0 ? (
        <div className="text-muted p-2">No calculations yet.</div>
      ) : (
        <table className="calculations-table">
          <thead>
            <tr>
              <th />
              <th>Name</th>
              <th>Expression</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((c) => (
              <tr key={c.id}>
                <td>
                  <input
                    type="checkbox"
                    style={{ accentColor: "#418172" }}
                    aria-label={`Select calculation ${c.name}`}
                    checked={selectedIds.includes(c.id)}
                    onChange={() => toggle(c.id)}
                  />
                </td>
                <td>
                  <button
                    type="button"
                    className="adminListEditLink calc-edit-link"
                    onClick={() => onEdit(c)}
                  >
                    {c.name}
                    <FontAwesomeIcon
                      icon={faPencil}
                      className="adminListEditLink__icon"
                    />
                  </button>
                </td>
                <td>{c.expression}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default CalculationsList;
